import tourSearchInput from '../../helpers/selectors/tourSearchInput';
import tourConnectionKey from '../../helpers/tourConnectionKey';
import { setTourCatalogLoad } from '../slices/tour';
import { setTourTripSearchParam, tourSearchRequest } from '../slices/tripSearch';

// A load sends up to fifty frames and each refresh is a GET /tours/search under the per-IP rate limit, so
// the list is refreshed at the end and at most every ten seconds in between.
const RefreshEveryMs = 10000;
const lastRefreshAt = {};

const onToursUpdated = (store, connections, handleRemoveConnection) => (res) => {
  const isTripSearch = !res.tripId;
  const connectionSlot = tourConnectionKey(res.tripId);
  const { requestId } = tourSearchInput(res.tripId, isTripSearch)(store.getState());
  if (requestId !== res.requestId) {
    return;
  }

  const saveLoad = (load) => {
    if (isTripSearch) {
      store.dispatch(setTourTripSearchParam(load));
    } else {
      store.dispatch(setTourCatalogLoad({ tripId: res.tripId, ...load }));
    }
  };

  saveLoad({ searchProgress: res.searchProgress, foundTotalTours: res.toursCount });

  const isFinalFrame = res.searchProgress === 100;
  const isRefreshDue = Date.now() - (lastRefreshAt[connectionSlot] || 0) >= RefreshEveryMs;
  if (!store.getState().tour.hasUserInteractedWithTourList && (isFinalFrame || isRefreshDue)) {
    lastRefreshAt[connectionSlot] = Date.now();
    store.dispatch(tourSearchRequest({ tripId: res.tripId, isTripSearch, isLoadingMore: true }));
  }

  if (res.searchProgress === 100) {
    const connection = connections[connectionSlot];
    if (connection && connection.stop) {
      connection.stop().then(() => {
        if (handleRemoveConnection && connections[connectionSlot] === connection) {
          handleRemoveConnection(connectionSlot);
        }
      });
    }
    setTimeout(() => {
      const current = tourSearchInput(res.tripId, isTripSearch)(store.getState());
      if (current.requestId === res.requestId) {
        saveLoad({ searchProgress: undefined });
      }
    }, 2000);
  }
};

export default onToursUpdated;
